/**
 * 任务初始化请求参数。
 */
export type StandardType = '3gpp' | 'itu' | 'wifi';

export interface TaskInitRequest {
    task_id: string;
    task_type: string;
    user_input: string;
    standard_type?: StandardType;
    model?: '' | 'deepseek' | 'qwen';
    metadata?: Record<string, unknown>;
}

/**
 * 任务初始化失败时的后端错误详情。
 */
export interface TaskInitResponseData {
    numeric_error_code?: number;
    error_code?: string;
    error_message?: string;
    message_vars?: string[];
    originating_service?: string;
    timestamp?: string;
    /** 多 PN 输入时，/task/init 返回的批量任务 ID。 */
    batch_task_id?: string;
    /** 多 PN 输入时返回的批量状态。 */
    status?: 'READY' | 'RUNNING' | 'SUCCESS' | 'PARTIAL_SUCCESS' | 'FAILED';
    /** 多 PN 输入解析、去重后的专利总数。 */
    total?: number;
}

export interface TaskInitResponse {
    status: boolean;
    error_code: number;
    error_msg?: string;
    data?: TaskInitResponseData;
}

export type EssentialityClaimTaskMode = 'single' | 'multiple';

export const TaskInitApi = Symbol('TaskInitApi');

/**
 * 任务初始化和任务类型识别 API。
 */
export interface TaskInitApi {
    initTask(request: TaskInitRequest): Promise<TaskInitResponse>;
}
